import { useState, useEffect } from "react";
import { useFonts } from "../utils/fonts";
import { Select, Option } from "../select";
import {
  MdFormatAlignCenter,
  MdFormatAlignLeft,
  MdFormatAlignRight,
  MdFormatUnderlined,
  MdFormatItalic,
} from "react-icons/md";
import Color from "./color";
import styles from "./styles.module.css";
import { textStyle } from ".";
export default function TextStyle({ value, onChange }) {
  const { fonts, families } = useFonts();
  const [_value, setValue] = useState({
    fontFamily: "Roboto",
    fontSize: 16,
    textAlign: "left",
    fontWeight: "400",
    fontStyle: "normal",
    textDecoration: "none",
    color: "#333",
  });

  const handleChange = (v, key) => {
    console.log("weight change");
    const newValue = { ..._value };
    newValue[key] = v;
    onChange(newValue);
  };

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, [value]);
  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex" }}>
        <div style={{ flexGrow: 2, flexBasis: 0 }}>
          <div className={styles.borderTitle}>Font</div>
          <FamilySearch
            onChange={(v) => handleChange(v, "fontFamily")}
            value={_value.fontFamily}
            families={families}
          />
        </div>
        <div style={{ marginLeft: 4, flexGrow: 1, flexBasis: 0 }}>
          <div className={styles.borderTitle}>Weight</div>
          <WeightSelect
            onChange={(v) => handleChange(v, "fontWeight")}
            value={_value.fontWeight}
            font={_value.fontFamily}
            fonts={fonts}
          />
        </div>
        <div style={{ flexGrow: 1, flexBasis: 0, marginLeft: 4 }}>
          <div className={styles.borderTitle}>Size</div>
          <Size
            value={_value.fontSize}
            onChange={(v) => handleChange(v, "fontSize")}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          marginTop: 10,
          justifyContent: "space-between",
        }}
      >
        <div>
          <div className={styles.borderTitle}>Color</div>
          <Color
            value={_value.color}
            onChange={(v) => handleChange(v, "color")}
          />
        </div>
        <div>
          <div className={styles.borderTitle}>Alignment</div>
          <div>
            <MdFormatAlignLeft
              style={{ marginLeft: 0 }}
              className={
                _value.textAlign === "left"
                  ? `${styles.icon} ${styles.active}`
                  : styles.icon
              }
              onClick={() => handleChange("left", "textAlign")}
            />
            <MdFormatAlignCenter
              className={
                _value.textAlign === "center"
                  ? `${styles.icon} ${styles.active}`
                  : styles.icon
              }
              onClick={() => handleChange("center", "textAlign")}
            />
            <MdFormatAlignRight
              className={
                _value.textAlign === "right"
                  ? `${styles.icon} ${styles.active}`
                  : styles.icon
              }
              onClick={() => handleChange("right", "textAlign")}
            />
          </div>
        </div>
        <div>
          <div className={styles.borderTitle}>Style</div>
          <div>
            <MdFormatUnderlined
              style={{ marginLeft: 0 }}
              className={
                _value.textDecoration === "underline"
                  ? `${styles.icon} ${styles.active}`
                  : styles.icon
              }
              onClick={() =>
                handleChange(
                  _value.textDecoration === "underline" ? "none" : "underline",
                  "textDecoration"
                )
              }
            />
            <MdFormatItalic
              className={
                _value.fontStyle === "italic"
                  ? `${styles.icon} ${styles.active}`
                  : styles.icon
              }
              onClick={() =>
                handleChange(
                  _value.fontStyle === "italic" ? "normal" : "italic",
                  "fontStyle"
                )
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const FamilySearch = ({ value, onChange, families }) => {
  const [_value, setValue] = useState("");
  const [focus, setFocus] = useState(false);

  useEffect(() => {
    setValue(value);
  }, [value]);

  const handleSelect = (e, fam) => {
    onChange(fam);
  };

  return (
    <div style={{ position: "relative" }}>
      <input
        style={{ boxSizing: "border-box", fontSize: 12, height: 29 }}
        className="input"
        value={_value}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        onChange={(e) => setValue(e.target.value)}
      />
      {focus && (
        <div
          style={{
            position: "absolute",
            top: 30,
            zIndex: 4000,
            border: "1px solid #E0E0E0",
            backgroundColor: "white",
            left: 0,
            right: 0,
            maxHeight: 240,
            overflowY: "scroll",
          }}
        >
          {families
            .filter((fam) => fam.includes(_value))
            .map((fam) => {
              return (
                <div
                  key={fam}
                  className={
                    fam === value
                      ? `${styles.searchItem} ${styles.active}`
                      : styles.searchItem
                  }
                  onMouseDown={(e) => handleSelect(e, fam)}
                >
                  {fam}
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};

const WeightSelect = ({ font, value, onChange, fonts = [] }) => {
  const [weights, setWeights] = useState([]);
  const [_value, setValue] = useState("");

  useEffect(() => {
    setValue(value);
  }, [value]);

  const handleSelect = (v) => {
    onChange(v);
  };
  useEffect(() => {
    try {
      const weights = fonts
        .find((x) => x.family === font)
        .variants.filter((x) => !x.includes("italic"))
        .map((x) => (x === "regular" ? "400" : x));
      setWeights(weights);
    } catch (err) {
      setWeights([]);
    }
  }, [font, fonts]);

  return (
    <Select value={_value} style={{ fontSize: 12 }} onChange={handleSelect}>
      {weights.map((w) => {
        return (
          <Option key={w} value={w}>
            {w}
          </Option>
        );
      })}
    </Select>
  );
};

const Size = ({ value, onChange }) => {
  const [_value, setValue] = useState("");

  useEffect(() => {
    setValue(value);
  }, [value]);

  const handleSave = () => {
    const num = parseFloat(_value);
    if (isNaN(num)) {
      onChange(null);
    } else {
      onChange(num);
    }
  };
  return (
    <input
      style={{ boxSizing: "border-box", fontSize: 12, height: 29 }}
      value={_value}
      onBlur={handleSave}
      className="input"
      type="number"
      onChange={(e) => setValue(e.target.value)}
    />
  );
};
